import React from "react";
import * as yup from "yup";
import Form from "components/Forms/Form";
import { InputType } from "components/Forms/Inputs/Input/types";
import QuestionInput from "components/Forms/Questions/QuestionInput";
import QuestionState from "components/Forms/Questions/QuestionState";
import { QuestionSizes } from "components/Forms/Questions/QuestionWrapper";
import TabbedButton, { TabbedButtonType } from "components/TabbedButton";
import { AnswersMap } from "modules/workflow/types/Answer";
import { Link } from "react-router-dom";

const schema = yup.object().shape({
  email: yup
    .string()
    .email("Please enter a valid email address.")
    .required("Email is required."),
  jurisdiction: yup.string().nullable().required("Please select a state."),
});

const emptyState = { email: "", jurisdiction: "" };

type Props = {
  isSubmitting: boolean;
  error: string;
  onSubmit: (values: AnswersMap) => void;
};

const cardStyle: React.CSSProperties = {
  backgroundColor: "#ffffff",
  borderRadius: "12px",
  padding: "40px",
  maxWidth: "480px",
  width: "100%",
  boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
  margin: "0 auto",
};

const PublicMedicaidEmailStep: React.FC<Props> = ({
  isSubmitting,
  error,
  onSubmit,
}) => (
  <div style={cardStyle}>
    <h2 style={{ fontSize: 22, fontWeight: 700, margin: "0 0 8px" }}>
      Medicaid Qualification Assessment
    </h2>
    <p
      style={{
        fontSize: 15,
        color: "#6b7280",
        margin: "0 0 28px",
        lineHeight: 1.5,
      }}
    >
      Enter your details below to begin your free Medicaid qualification
      assessment.
    </p>

    {error && (
      <p
        style={{
          color: "#dc2626",
          marginBottom: 16,
          fontSize: 13,
          display: "flex",
          alignItems: "center",
          gap: 8,
          flexWrap: "wrap",
        }}
      >
        {error}
        {error ===
          "Your account already exists. Please sign in to continue." && (
          <Link
            to="/login"
            style={{
              whiteSpace: "nowrap",
              marginLeft: "auto",
              textDecoration: "underline",
            }}
          >
            Go to sign in
          </Link>
        )}
      </p>
    )}

    <Form
      state={emptyState}
      schema={schema}
      onSave={onSubmit}
      showSaveButton
      renderFooter={(submitHandle) => (
        <TabbedButton
          style={TabbedButtonType.PRIMARY}
          disabled={isSubmitting}
          onClick={() => submitHandle()}
        >
          Start Assessment
        </TabbedButton>
      )}
    >
      <QuestionInput
        type={InputType.EMAIL}
        label="Email Address"
        name="email"
        placeholder="you@example.com"
        size={QuestionSizes.FULLWIDTH}
      />
      <QuestionState
        label="State"
        name="jurisdiction"
        placeholder="Please select the state"
        size={QuestionSizes.FULLWIDTH}
      />
    </Form>
  </div>
);

export default PublicMedicaidEmailStep;
